import { User } from '../../user/user.model';
import { PeriodType } from '../../widget/date-range.widget.model';

export const MAX_SHOWABLE_RANGE = 4;

export interface CoachingCoverageContext {
    user: User;
    periodType: PeriodType;
    periodDate: Date;
}
